import type { ReactNode } from "react"
import { TooltipProvider } from "@/ui/components/ui/tooltip"
import { ThemeProvider } from "@/ui/components/theme-provider"
import { Toaster } from "@/ui/components/ui/sonner"

type Props = {
  children: ReactNode
}

export default function UiProvider({ children }: Props) {
  return (
    <ThemeProvider>
      <TooltipProvider>
        {children}
        <Toaster />
      </TooltipProvider>
    </ThemeProvider>
  )
}
